export const pricingInfo: PricingInfoType = {
  userLicense: {
    "AUD": "A$16.50",
    "CAD" : "C$14.50",
    "CHF" : "₣9.50",
    "EUR" : "€10.00",
    "GBP" : "£8.50",
    "USD" : "$10.00",
  },
  disclaimer :{
    "AUD": "A$15.00",
    "CAD" : "C$13.00",
    "CHF" : "₣8.50",
    "EUR" : "€9.00",
    "GBP" : "£7.50",
    "USD" : "$9.00",
  },
  projectFee: {
    "AUD": "A$15.00",
    "CAD" : "C$13.00",
    "CHF" : "₣8.50",
    "EUR" : "€9.00",
    "GBP" : "£7.50",
    "USD" : "$9.00",
  },
  diskStorage: {
    "AUD": "A$0.83",
    "CAD" : "C$0.72",
    "CHF" : "₣0.47",
    "EUR" : "€0.49",
    "GBP" : "£0.42",
    "USD" : "$0.50",
  },
  backups: {
    "AUD": "A$0.17",
    "CAD" : "C$0.14",
    "CHF" : "₣0.09",
    "EUR" : "€0.10",
    "GBP" : "£0.08",
    "USD" : "$0.10",
  },
  logs: {
    "AUD": "A$0.10",
    "CAD" : "C$0.10",
    "CHF" : "₣0.10",
    "EUR" : "€0.10",
    "GBP" : "£0.10",
    "USD" : "$0.10",
  },
  continuousProfiling: {
    "AUD": "A$8.28",
    "CAD" : "C$7.19",
    "CHF" : "₣4.69",
    "EUR" : "€4.89",
    "GBP" : "£4.19",
    "USD" : "$4.99",
  },
  userManagementFee: {
    "AUD": "A$15.00",
    "CAD" : "C$13.00",
    "CHF" : "₣8.50",
    "EUR" : "€9.00",
    "GBP" : "£7.50",
    "USD" : "$9.00",
  },
  egress :{
    "AUD": "A$0.05",
    "CAD" : "C$0.04",
    "CHF" : "₣0.03",
    "EUR" : "€0.03",
    "GBP" : "£0.03",
    "USD" : "$0.03",
  },
  ingress :{
    "AUD": "A$1.00",
    "CAD" : "C$1.00",
    "CHF" : "₣1.00",
    "EUR" : "€1.00",
    "GBP" : "£1.00",
    "USD" : "$1.00",
  },
  additionalBuild :{
    "AUD": "A$0.01",
    "CAD" : "C$0.01",
    "CHF" : "₣0.01",
    "EUR" : "€0.01",
    "GBP" : "£0.01",
    "USD" : "$0.01",
  },
  egressBandwidth: {
    "AUD": "A$0.05",
    "CAD" : "C$0.04",
    "CHF" : "₣0.03",
    "EUR" : "€0.03",
    "GBP" : "£0.03",
    "USD" : "$0.03",
  },
  ingressRequests: {
    "AUD": "A$1.00",
    "CAD" : "C$1.00",
    "CHF" : "₣1.00",
    "EUR" : "€1.00",
    "GBP" : "£1.00",
    "USD" : "$1.00",
  },
  fastlyBandwidth: {
    "AUD": "A$0.153",
    "CAD" : "C$0.137",
    "CHF" : "₣1.00",
    "EUR" : "€0.094",
    "GBP" : "£0.08",
    "USD" : "$0.10",
  },
  fastlyRequests: {
    "AUD": "A$0.306",
    "CAD" : "C$0.274",
    "CHF" : "₣1.00",
    "EUR" : "€0.188",
    "GBP" : "£0.159",
    "USD" : "$0.20",
  },
  freeTrial: {
    "AUD": "A$0",
    "CAD" : "C$0",
    "CHF" : "₣0",
    "EUR" : "€0",
    "GBP" : "£0",
    "USD" : "$0",
  },
  objectStorageEnv: {
    "AUD": "A$0.1590",
    "CAD" : "C$0.138",
    // "CHF" : "₣0",
    "EUR" : "€0.0833",
    "GBP" : "£0.0805",
    "USD" : "$0.0958",
  },
  objectStorageBackups: {
    "AUD": "A$0.1431",
    "CAD" : "C$0.1242",
    // "CHF" : "₣0",
    "EUR" : "€0.075",
    "GBP" : "£0.0725",
    "USD" : "$0.0862",
  },
};

export const applicationPricing: PricingInfoType = {
  cpuHourly: {
    "AUD": "A$0.057",
    "CAD" : "C$0.049",
    "CHF" : "₣0.032",
    "EUR" : "€0.033",
    "GBP" : "£0.029",
    "USD" : "$0.034",
  },
  cpuMonthly: {
    "AUD": "A$41.50",
    "CAD" : "C$36.00",
    "CHF" : "₣23.50",
    "EUR" : "€24.50",
    "GBP" : "£21.00",
    "USD" : "$25.00",
  },
  guaranteedCpuHourly: {
    "AUD": "A$0.170",
    "CAD" : "C$0.148",
    "CHF" : "₣0.000",
    "EUR" : "€0.100",
    "GBP" : "£0.086",
    "USD" : "$0.102",
  },
  guaranteedCpuMonthly: {
    "AUD": "A$124.50",
    "CAD" : "C$108.00",
    "CHF" : "₣00.00",
    "EUR" : "€73.50",
    "GBP" : "£63.00",
    "USD" : "$75.00",
  },
  memoryHourly: {
    "AUD": "A$0.023",
    "CAD" : "C$0.020",
    "CHF" : "₣0.013",
    "EUR" : "€0.013",
    "GBP" : "£0.011",
    "USD" : "$0.014",
  },
  memoryMonthly: {
    "AUD": "A$16.60",
    "CAD" : "C$14.40",
    "CHF" : "₣9.40",
    "EUR" : "€9.80",
    "GBP" : "£8.40",
    "USD" : "$10.00",
  },
};

export const servicesPricing: PricingInfoType = {
  cpuHourly: {
    "AUD": "A$0.084",
    "CAD" : "C$0.073",
    "CHF" : "₣0.047",
    "EUR" : "€0.049",
    "GBP" : "£0.042",
    "USD" : "$0.050",
  },
  cpuMonthly: {
    "AUD": "A$61.42",
    "CAD" : "C$53.28",
    "CHF" : "₣34.78",
    "EUR" : "€36.26",
    "GBP" : "£31.08",
    "USD" : "$37.00",
  },
  guaranteedCpuHourly: {
    "AUD": "A$0.204",
    "CAD" : "C$0.177",
    "CHF" : "₣0.000",
    "EUR" : "€0.120",
    "GBP" : "£0.103",
    "USD" : "$0.123",
  },
  guaranteedCpuMonthly: {
    "AUD": "A$149.40",
    "CAD" : "C$129.60",
    "CHF" : "₣00.00",
    "EUR" : "€88.20",
    "GBP" : "£75.60",
    "USD" : "$90.00",
  },
  memoryHourly: {
    "AUD": "A$0.034",
    "CAD" : "C$0.029",
    "CHF" : "₣0.019",
    "EUR" : "€0.020",
    "GBP" : "£0.017",
    "USD" : "$0.020",
  },
  memoryMonthly: {
    "AUD": "A$24.90",
    "CAD" : "C$21.60",
    "CHF" : "₣14.10",
    "EUR" : "€14.70",
    "GBP" : "£12.60",
    "USD" : "$15.00",
  },
};

export const dropdownOptions = [
  {
    text: "Project resources",
    href: "#project-resources"
  },
  {
    text: "User management",
    href: "#user-licenses"
  },
  {
    text: "All features",
    href: "#all-features"
  },
  {
    text: "All services",
    href: "#all-services"
  },
];


export const fastlyPricing: any = {
  basic: {
    "0-1M": {
      "AUD": "A$138.00",
      "CAD" : "C$123.00",
      "EUR" : "€85.00",
      "GBP" : "£72.00",
      "USD" : "$90.00",
    },
    "1-2M": {
      "AUD": "A$69.00",
      "CAD" : "C$62.00",
      "EUR" : "€42.00",
      "GBP" : "£36.00",
      "USD" : "$45.00",
    },
    "2-3M": {
      "AUD": "A$53.00",
      "CAD" : "C$48.00",
      "EUR" : "€33.00",
      "GBP" : "£28.00",
      "USD" : "$35.00",
    },
    "3M+": {
      "AUD": "A$38.00",
      "CAD" : "C$34.00",
      "EUR" : "€24.00",
      "GBP" : "£20.00",
      "USD" : "$25.00",
    },
  },
  configurable: {
    "0-2M": {
      "AUD": "A$725.00",
      "CAD" : "C$650.00",
      "EUR" : "€445.00",
      "GBP" : "£380.00",
      "USD" : "$475.00",
    },
    "2-3M": {
      "AUD": "A$53.00",
      "CAD" : "C$48.00",
      "EUR" : "€33.00",
      "GBP" : "£28.00",
      "USD" : "$35.00",
    },
    "3M+": {
      "AUD": "A$38.00",
      "CAD" : "C$34.00",
      "EUR" : "€24.00",
      "GBP" : "£20.00",
      "USD" : "$25.00",
    },
  },
  imageOptimization: {
    "0-50M": {
      "AUD": "A$92.00",
      "CAD" : "C$82.00",
      "EUR" : "€56.00",
      "GBP" : "£48.00",
      "USD" : "$60.00",
    },
    "50M+": {
      "AUD": "A$46.00",
      "CAD" : "C$41.00",
      "EUR" : "€28.00",
      "GBP" : "£24.00",
      "USD" : "$30.00",
    },
  },
  rateLimiting: {
    "AUD": "A$84.00",
    "CAD" : "C$75.00",
    "EUR" : "€52.00",
    "GBP" : "£44.00",
    "USD" : "$55.00",
  },
  ddosProtection: {
    "AUD": "A$275.00",
    "CAD" : "C$246.00",
    "EUR" : "€169.00",
    "GBP" : "£143.00",
    "USD" : "$180.00",
  },
  tlsCertificates: {
    "standard": {
      "AUD": "A$14.00",
      "CAD" : "C$12.00",
      "EUR" : "€8.50",
      "GBP" : "£7.50",
      "USD" : "$9.00",
    },
    "customerGenerated": {
      "AUD": "A$304.00",
      "CAD" : "C$272.00",
      "EUR" : "€187.00",
      "GBP" : "£158.00",
      "USD" : "$199.00",
    },
  }
};

// Slack thread where pricing team tells me do just divide the monthly price 
// by 732 to get the hourly price for mongodb and elasticsearch and how to round:
// https://platformsh.slack.com/archives/C0LMA1NAJ/p1770913702385719?thread_ts=1767611529.384779&cid=C0LMA1NAJ
export const mongodbPricing: PricingInfoType = {
  feeMonthly: {
    "AUD": "A$61.00",
    "CAD" : "C$54.50",
    "EUR" : "€37.50",
    "GBP" : "£31.50",
    "USD" : "$40.00",
  },
  feeHourly: {
    "AUD": "A$0.08",
    "CAD" : "C$0.07",
    "EUR" : "€0.05",
    "GBP" : "£0.04",
    "USD" : "$0.05",
  },
};

export const elasticsearchPricing: PricingInfoType = {
  feeMonthly: {
    "AUD": "A$221.00",
    "CAD" : "C$198.00",
    "EUR" : "€136.00",
    "GBP" : "£115.00",
    "USD" : "$145.00",
  },  
  feeHourly: {
    "AUD": "A$0.30",
    "CAD" : "C$0.27",
    "EUR" : "€0.19",
    "GBP" : "£0.16",
    "USD" : "$0.20",
  },
};
